import { useHistory } from 'react-router-dom';
import { openRemoteModalWrapper } from 'src/components/pages/legacy/components/open-legacy-remote-modal-link';
import { useUrls } from 'src/hooks/use-urls';
import { useShowInlineForms } from '../../../../hooks/use-show-inline-forms';

export const useEditContactModal = () => {
  const { getLegacyContactEditUrl, getEditContactUrl } = useUrls();
  const showInlineForm = useShowInlineForms();
  const history = useHistory();

  const showEditContactModal = (contactId: number) => {
    const contactModalUrl = showInlineForm
      ? getEditContactUrl(contactId)
      : getLegacyContactEditUrl(contactId);

    if (showInlineForm) {
      history.push(contactModalUrl);
    } else {
      openRemoteModalWrapper(contactModalUrl);
    }
  };

  return { showEditContactModal };
};
